import type { FeedItem as FeedItemType } from '@olimhub/shared'
import { PostCard } from '@/components/post/PostCard'
import { BoostCard } from '@/components/post/BoostCard'
import { TranslationCard } from '@/components/post/TranslationCard'
import { HelpCard } from '@/components/post/HelpCard'
import type { Post, EventPost, OfferPost, HelpPost, Boost, Translation } from '@olimhub/shared'

interface FeedItemProps {
  item: FeedItemType
  readOnly?: boolean
  onBoost?: (id: string) => void
  onReport?: (id: string) => void
  hideGroupAttribution?: boolean
  // Set by GroupPage when the viewer is that group's group_admin. Only
  // grants edit/delete on posts actually authored by the group's mirror
  // account (post_as_group) — never on a member's own tagged post, which
  // still follows normal single-author rules.
  viewerIsGroupAdmin?: boolean
}

export function FeedItem({ item, readOnly, onBoost, onReport, hideGroupAttribution, viewerIsGroupAdmin }: FeedItemProps) {
  if (item.kind === 'post') {
    const canManage = !!viewerIsGroupAdmin && (item.data as Post).account.accountType === 'group'
    if ((item.data as Post).type === 'help') {
      return (
        <HelpCard
          post={item.data as HelpPost}
          readOnly={readOnly}
          onReport={onReport}
          hideGroupAttribution={hideGroupAttribution}
          canManage={canManage}
        />
      )
    }
    return (
      <PostCard
        post={item.data as Post | EventPost | OfferPost}
        readOnly={readOnly}
        onBoost={onBoost}
        onReport={onReport}
        hideGroupAttribution={hideGroupAttribution}
        canManage={canManage}
      />
    )
  }

  if (item.kind === 'boost') {
    return (
      <BoostCard
        boost={item.data as Boost}
        readOnly={readOnly}
        onBoost={onBoost}
        onReport={onReport}
      />
    )
  }

  if (item.kind === 'translation') {
    return (
      <TranslationCard
        translation={item.data as Translation}
        readOnly={readOnly}
        onBoost={onBoost}
        onReport={onReport}
      />
    )
  }

  return null
}
